/**
 * AS-1832 — Segment event names fired from interviewer_frontend (AI
 * Screener 3.0). Names mirror the v2 screener_frontend vocabulary so
 * Lisa's funnel dashboards work across both interview generations
 * without bespoke per-version queries.
 */
export const AnalyticsEvents = {
  // Lifecycle
  LandedOnScreener: "Landed on Screener",
  StartScreening: "Start Screening",
  CompleteScreening: "Complete Screening",
  ScreenerTimeout: "Screener Timeout",
  ResumePageLoaded: "Resume Page Loaded",
  ResumeScreener: "Resume Screener",
  RestartScreener: "Restart Screener",

  // Voice
  VoiceResponseSubmitted: "Voice response submitted",
  VoiceRecordingDiscarded: "Voice recording discarded",
  VoiceModeSwitchedToText: "Voice mode switched to text",
  TextModeSwitchedToVoice: "Text mode switched to voice",
  MicrophonePermissionDenied: "Microphone permission denied",

  // AS-1564 — Progress bar
  ProgressIndicatorViewed: "Progress Indicator Viewed",

  // AS-1866 — Post-interview candidate feedback (mirrors v2 screener_frontend)
  FeedbackSubmitted: "Feedback Submitted",

  // AS-1565 — Edit previous response
  PreviousQuestionClicked: "Previous Question Clicked",
  PreviousQuestionEdited: "Previous Question Edited",
  PreviousQuestionEditSubmitted: "Previous Question Edit Submitted",
  PreviousQuestionEditAbandoned: "Previous Question Edit Abandoned",
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
